import { makeStyles } from '@mui/styles';

const useUserInfoStyles = makeStyles({
	root: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		fontFamily: 'Montserrat',
		width: '100%',
	},
	rootBig: {
		backgroundColor: '#207cc2',
		borderRadius: 4,
		color: 'white',
		padding: 8,
	},
	rootPopUp: {
		backgroundColor: 'transparent',
	},
	rootSmall: {
		padding: 0,
		paddingLeft: 12,
		paddingBottom: 10,
	},
	rootToggle: {
		borderBottom: '1px solid rgba(250, 250, 250, 0.36)',
		borderRadius: 0,
		color: 'white',
		padding: '8px 14px 12px 14px',
	},
	avatarContainer: {
		position: 'relative',
	},
	cameraContainer: {
		alignItems: 'center',
		backgroundColor: 'white',
		borderRadius: '50%',
		boxShadow: '0px 3px 6px #00000029',
		color: '#686868',
		cursor: 'pointer',
		display: 'flex',
		height: 24,
		justifyContent: 'center',
		position: 'absolute',
		right: 0,
		transform: 'translateY(-75%)',
		width: 24,
	},
	infoContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		width: 'calc(100% - 44px)',
	},
	infoContainerLeft: {
		marginLeft: 8,
		width: 'calc(100% - 24px - 7px - 12px)',
	},
	infoContainerLeftBig: {
		width: 'auto',
	},
	fullName: {
		fontSize: 12,
		fontWeight: 600,
		lineHeight: 1,
		margin: 0,
		padding: 0,
		textTransform: 'capitalize',
	},
	fullNameBig: {
		fontSize: 14,
	},
	email: {
		fontSize: 10,
		fontWeight: 400,
		letterSpacing: 0.25,
		lineHeight: 1,
		margin: 0,
		marginTop: 2,
		maxWidth: '100%',
		overflow: 'hidden',
		padding: 0,
		textOverflow: 'ellipsis',
	},
	emailBig: {
		marginTop: 3,
		textOverflow: 'initial',
	},
	infoContainerRight: {
		height: 24,
		marginLeft: 12,
		marginRight: 7,
		width: 24,
	},
});

export default useUserInfoStyles;
